// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import { createMemoryHistory, createRouter } from "vue-router";
import CrmContactEmail from "../views/ContactEmail.vue";
import CrmBusinessEmail from "../views/BusinessEmail.vue";
import CrmAccountEmail from "../views/AccountEmail.vue";
import CrmLeadEmail from "../views/LeadEmail.vue";
import CrmWelcome from "../views/Welcome.vue";
import CrmEntityCreation from "../views/EntityCreation.vue";
import CrmLeadEntityCreation from "../views/LeadEntityCreation.vue";
import oidcManager from "../authentication/oidcManager";

export const routerHistory = createMemoryHistory();

let router: any = null;
/**
 * Initializes the Vue router
 * @returns {object}
 */
export const initRouter = function () {
  router = createRouter({
    history: routerHistory,
    strict: true,
    routes: [
      {
        path: "/",
        name: "contact",
        component: CrmContactEmail,
      },
      {
        path: "/business",
        name: "business",
        component: CrmBusinessEmail,
      },
      {
        path: "/lead",
        name: "lead",
        component: CrmLeadEmail,
      },
      {
        path: "/account",
        name: "account",
        component: CrmAccountEmail,
      },
      {
        path: "/welcome",
        name: "welcome",
        component: CrmWelcome,
        meta: {
          isPublic: true,
        },
      },
      {
        path: "/entitycreation/:emailAddress/:name/:isSender",
        name: "entity-creation",
        component: CrmEntityCreation,
        props: true,
      },
      {
        path: "/leadentitycreation/:emailAddress/:name/:isSender",
        name: "lead-entity-creation",
        component: CrmLeadEntityCreation,
        props: true,
      },
    ],
  });

  oidcManager.initRouter(router);
  return router;
};

const useRouter = () => {
  return router;
};

export { useRouter };
